<template>
  <div class="home">
    <Hero
      title=""
      image="banner-home.jpeg"
      :search="false"
    />

    <div class="row p-5 bg-wl-secondary rounded-xl mt-n5" id="sub-hero">
      <div class="col-12 col-md-9 mx-auto">
        <div class="row">
          <div class="col-12 col-md-6">
            <h2 class="text-white">Venha fazer parte da equipe de pista da rede de Postos Petrobras*</h2>
            <h2 class="text-wl-primary mb-5">Cadastre-se agora!</h2>
          </div>

          <div class="col-12 col-md-6">
            <router-link :to="`/banco-de-talentos/${$store.state.bancoDeTalentos}/inscricao`" class="btn btn-lg btn-block btn-wl-primary rounded-xl shadow" :class="[ enrolledBancoDeTalentos ? 'disabled' : '' ]">
              {{ enrolledBancoDeTalentos ? "Você já está inscrito" : "Deixe seu currículo" }}
            </router-link>

            <p class="text-white" style="font-size: 16px; margin-top: 15px;">Quer trabalhar em um posto da rede Petrobras?<br />Cadastre-se no banco de talentos para ter acesso às vagas de frentista ou de outras funções dentro de um posto de serviços.</p>

            <p class="text-white" style="font-size: 16px;">*A oferta de vagas é de responsabilidade exclusiva dos revendedores dos postos, sem qualquer vínculo empregatício com a Vibra Energia S.A ou a Petrobras – Petróleo Brasileiro S.A.</p>
          </div>
        </div>
      </div>
    </div>

    <div class="row py-5 mt-5" id="opportunities-carousel">
      <div class="col-12" v-if="opportunities.length > 0">
        <Slider :responsive="sliderResponsive">
          <div v-for="(opportunity, id) in opportunities" :key="id" class="d-flex justify-content-center">
            <JobBox
              :opportunity="opportunity"
              :id="id"
              :showModalKnowMoreButton="false"
              :btnSubscriptionText="'Inscrever-se'"
              :showDescriptionPage="true"
              class=""
              ></JobBox>
          </div>
        </Slider>
      </div>
    </div>

    <div class="row my-5 py-5" id="videos" v-if="$store.state.user.isAuth">
      <div class="col-12 col-md-10 mx-auto mb-5">
        <h1 class="text-center text-wl-secondary">Não perca a oportunidade de trabalhar na maior Rede de Postos do Brasil!</h1>
      </div>

      <div class="col-12 col-md-10 mx-auto">
        <Gallery
          :items="videos"
          :custom_class="'flex-column flex-lg-row'"
          itemsW="49%"
          itemsH="400px"
        />
      </div>
    </div>

    <div class="row mt-5" id="about">
      <div class="col-12 col-md-6 mx-auto mb-5">
        <h1 class="text-center mb-3" id="sobre">Sobre</h1>
        <p>O “Talentos na Pista” é uma iniciativa da Vibra para promover a parceria entre a 99jobs, empresa de plataforma de recrutamento e seleção e o Capacidade Máxima, o programa de treinamento dos postos Petrobras, com o intuito de facilitar o processo tanto para quem se candidata, quanto para quem contrata na rede de postos Petrobras.</p>

        <p>Ao se cadastrar no banco de talentos, você estará inserido em uma ampla rede de oportunidades e poderá ingressar no mercado de trabalho, através de uma vaga num posto da rede Petrobras. Através da plataforma, seu perfil será disponibilizado para as vagas correspondentes e poderá ser selecionado para as entrevistas e processos seletivos de postos que buscam por profissionais qualificados em diversas áreas de atuação.</p>

        <p>Não perca a oportunidade de trabalhar na maior Rede de Postos do Brasil! Boa sorte!</p>
      </div>
    </div>


  </div>
</template>

<script>
// @ is an alias to /src
import Hero from "@/components/media/Hero.vue";
import Slider from "@/components/media/Slider.vue";
import Gallery from "@/components/media/Gallery.vue";
import JobBox from "ninenine-white-label/src/components/JobBox/JobBox.vue";

export default {
  name: "Home",

  data() {
    return {
    }
  },

  computed: {
    opportunities(){
      return this.$store.state.opportunities.all || []
    },

    videos() {
      return [
        {
          src: "https://www.youtube.com/embed/-a3f5DpqI5s",
          thumb: "capa-video-1.jpg",
          isVideo: true,
          text: 'Conheça aqui o papel de um frentista dos Postos Petrobras'
        },
        {
          src: "https://www.youtube.com/embed/GRfalsLUjjw",
          thumb: "capa-video-2.jpg",
          isVideo: true,
          text: 'Conheça aqui o papel de um gerente dos Postos Petrobras'
        }
      ]
    },

    faqItems() {
      return this.$store.state.faqItems;
    },

    enrolledBancoDeTalentos() {
      return !!this.$store.state.opportunities.subscriptions.find(
        (subs) => subs.opportunityId == process.env.VUE_APP_BANCO_DE_TALENTOS
      );
    },

    sliderResponsive() {
      return {
        2000: {
          loop: true,
          items: this.opportunities.length >= 5 ? 5 : 1,
          edgePadding: 130,
          nav: false,
          startIndex: 0
        },

        1500: {
          loop: true,
          items: this.opportunities.length >= 4 ? 4 : 1,
          edgePadding: 130,
          nav: false,
          startIndex: 0
        },

        1400: {
          loop: true,
          items: this.opportunities.length >= 3 ? 3 : 1,
          edgePadding: 130,
          nav: false,
          startIndex: 1
        },

        1200: {
          loop: true,
          items: this.opportunities.length >= 3 ? 3 : 1,
          edgePadding: 130,
          nav: false,
          startIndex: 1
        },

        992: {
          loop: true,
          items: this.opportunities.length >= 2 ? 2 : 1,
          edgePadding: 90,
          nav: false,
          startIndex: 1
        },

        768: {
          loop: true,
          items: 1,
          edgePadding: 90,
          nav: true,
          startIndex: 1
        },

        576: {
          loop: true,
          items: 1,
          edgePadding: 40,
          nav: true,
          startIndex: 1
        },

        0: {
          loop: true,
          items: 1,
          edgePadding: 40,
          nav: true
        }
      }
    }
  },

  components: {
    Hero,
    Slider,
    Gallery,
    JobBox,
  },

  mounted() {
    this.$store.dispatch("opportunities/setOpportunities");
  }
};
</script>

<style lang="scss" scoped>
.home{
  /deep/.hero:after{
    background-image: url('~@/assets/images/logo-powered.png');
    background-size: 300px;
  }

  /deep/.hero > .media-content > img{
    object-position: bottom left;
  }

  #opportunities-carousel {
    /deep/ .carousel-itens{
      padding: 10px;
    }

    /deep/ .carousel-controls{
      transform: translate(-50%, -40px);
    }

    /deep/ .job-box{
      max-width: 400px;
      height: 100%;
      display: flex;
      flex-direction: column;

      & > div{
        flex: 0;
      }

      .opportunity-buttons-container{
        margin-top: auto;
      }

      .modal-job-box-wrapper{
        display: none;
      }
    }
  }

  #about{
    background-image: url('~@/assets/images/bg-rounded.png');
    background-size: cover;
    background-position: top;
    padding-top: 500px;

    @media screen and (min-width: 0px) {
      padding-top: 350px;
    }

    @media screen and (min-width: 500px) {
      padding-top: 250px;
    }

    @media screen and (min-width: 800px) {
      padding-top: 300px;
    }

    @media screen and (min-width: 1000px) {
      padding-top: 400px;
    }

    @media screen and (min-width: 1200px) {
      padding-top: 450px;
    }

    @media screen and (min-width: 1400px) {
      padding-top: 500px;
    }

    @media screen and (min-width: 1600px) {
      padding-top: 550px;
    }

  }
}

</style>
